import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import TopBar from './components/layout/topbar';
import SideBar from './components/layout/sidebar';
import Footer from './components/layout/footer';
import BackToTopButton from './components/layout/backToTopButton';
import Dashboard from './components/pages/dashboard';
import GatewaysPage from './components/pages/gateways';
import DevicesPage from './components/pages/devices';
import LoginCard from './components/pages/login';
import useThemeStore from "./context/themeContext";
import Gateway from './components/pages/gateway';
import Device from './components/pages/device';
import NotFound from './components/pages/notFound';
import { useEffect } from 'react';

function App() {
  // const location = useLocation();
  const shouldShowNavAndFooter = window.location.pathname !== '/';

  const { currentTheme } = useThemeStore();

  useEffect(() => {
    // Set the initial theme on app load
    document.body.classList.add(currentTheme === "light" ? "light-theme" : "dark-theme");
  }, [currentTheme]);

  useEffect(() => {
    document.title = "Network Management System";
  }, []);

  return (

    <div className="App flex flex-col justify-start bg-gradient-to-r from-[var(--gradientFirst)] to-[var(--gradientSecond)]">

      {shouldShowNavAndFooter && <TopBar />}
      <SideBar />
      {/* <Navbar /> */}

      <main className='px-8'>
        <Router>
          <Routes>
            <Route path="/" element={<LoginCard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/gatewaysTable" element={<GatewaysPage />} />
            <Route path="/devicesTable" element={<DevicesPage />} />
            <Route path="/gateways/:id" element={<Gateway />} />
            <Route path="/gateways/:id/:server" element={<Gateway />} />
            <Route path="/devices/:deveui" element={<Device />} />
            <Route path="/devices/:deveui/:server" element={<Device />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </main>

      {shouldShowNavAndFooter && <BackToTopButton />}
      {/* <Footer /> */}
    </div>
  );
}

export default App;